import React from 'react'

/**
 * @param {Object} props - The props
 * @param {JSX.Element} props.metaItems - The meta items
 * @param {JSX.Element} props.actionButtons - The action buttons
 * @returns {JSX.Element} DetailPageV3ActionBar
 */

const DetailPageV3ActionBar = (props) => {
  const {
    metaItems = null,
    actionButtons = null,
  } = props

  return (
    <div className="detail-page-v3__columns-layout detail-page-v3__columns-layout--space-between">
      <div className="detail-page-v3__row">
        {metaItems}
      </div>
      <div className="detail-page-v3__row detail-page-v3__row--actions">
        {actionButtons}
      </div>
    </div>
  )
}

export default DetailPageV3ActionBar
